/* American Garage Door Supply - ASTA rolling steel doors hub + quote request.
   Scoped to [data-rsd-quote]. No dependencies. No credentials.

   Flow: step 1 collects door / project details on this page and validates them.
   Step 2 loads the existing AGDS HighLevel website form (the same one used on
   /pages/contact) with the door details prefilled into its message box through
   the form's documented URL query keys. Contact details and free-text notes are
   typed only inside that native form, never into this page or any URL. */
(function () {
  'use strict';

  var root = document.querySelector('[data-rsd-quote]');
  if (!root) return;

  var form = root.querySelector('[data-rsd-form]');
  var step1 = root.querySelector('[data-rsd-step1]');
  var step2 = root.querySelector('[data-rsd-step2]');
  var summaryEl = root.querySelector('[data-rsd-summary]');
  var embedEl = root.querySelector('[data-rsd-embed]');
  var errorBox = root.querySelector('[data-rsd-errors]');
  var statusEl = root.querySelector('[data-rsd-status]');
  var stepItems = root.querySelectorAll('[data-rsd-stepitem]');
  if (!form || !step1 || !step2 || !summaryEl || !embedEl) return;

  var FORM_ID = root.getAttribute('data-form-id') || '';
  var FORM_NAME = root.getAttribute('data-form-name') || 'AGDS website form';
  var FORM_HOST = 'https://api.leadconnectorhq.com/widget/form/';
  var STORE_KEY = 'agdsRsdQuoteV1';
  var MAX_URL = 6000;
  var loadedSummary = null;   // summary the currently loaded native form was built from
  var slowTimer = null;       // pending "form slow to load" notice

  var SERIES = {
    '200': root.getAttribute('data-series-200-label') || '200 Series - Commercial sheet door',
    '300': '300 Series - Commercial Slat Door',
    '400': '400 Series - Heavy-Duty Rolling Service Door',
    '400HP': '400HP Series - High-Performance Rolling Service Door',
    '500': '500 Series - Rolling Fire Door',
    '500i': '500i Series - Insulated Rolling Fire Door',
    '550': '550 Series - Fire-Rated Counter Shutter',
    '600': '600 Series - Insulated Rolling Service Door',
    '700': '700 Series - Counter Shutter',
    '800': '800 Series - Rolling Grille',
    '800HP': '800HP Series - High-Performance Rolling Grille'
  };

  function $(name) { return form.elements[name]; }
  function val(name) {
    var el = $(name);
    if (!el) return '';
    if (el.length && !el.tagName) { // RadioNodeList
      for (var i = 0; i < el.length; i++) if (el[i].checked) return el[i].value;
      return '';
    }
    if (el.type === 'checkbox') return el.checked ? 'yes' : '';
    return (el.value || '').trim();
  }

  /* Short technical values only. Anything that looks like an email address or
     a phone number is removed so contact data cannot end up in the iframe URL. */
  function scrub(text, max) {
    var t = String(text || '')
      .replace(/[\w.+-]+@[\w-]+\.[\w.-]+/g, '')
      .replace(/(?:\+?\d[\s().-]*){7,}/g, '')
      .replace(/https?:\/\/\S+/gi, '')
      .replace(/[<>{}\[\]\\]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    return t.slice(0, max || 60);
  }

  /* ---------- conditional fields ---------- */
  function syncConditionals() {
    var series = val('series');
    var poweredOnly = series === '400HP' || series === '800HP';
    var operation = $('operation');
    for (var o = 0; o < operation.options.length; o++) {
      var option = operation.options[o];
      option.disabled = poweredOnly && option.value !== '' && option.value !== 'motor';
    }
    if (poweredOnly && val('operation') && val('operation') !== 'motor') operation.value = '';
    var warning = root.querySelector('[data-rsd-compatibility]');
    if (warning) {
      var fireMismatch = val('need_fire') === 'yes' && series && ['500', '500i', '550'].indexOf(series) === -1;
      var insulationMismatch = val('need_insulation') === 'yes' && series && ['600', '500i'].indexOf(series) === -1;
      warning.hidden = !fireMismatch && !insulationMismatch;
      warning.textContent = fireMismatch ? 'The selected series is not fire-rated. You can continue with your requirements; our team will help select a rated assembly.' : insulationMismatch ? 'The selected series does not have an insulated curtain. You can continue with your requirements; our team will help select an insulated door.' : '';
    }
    var rules = root.querySelectorAll('[data-rsd-show-when]');
    for (var i = 0; i < rules.length; i++) {
      var parts = rules[i].getAttribute('data-rsd-show-when').split('=');
      var show = val(parts[0]) === parts[1];
      rules[i].hidden = !show;
      var inputs = rules[i].querySelectorAll('input, select, textarea');
      for (var j = 0; j < inputs.length; j++) inputs[j].disabled = !show;
    }
    var unknown = val('size_unknown') === 'yes';
    var dims = root.querySelectorAll('[data-rsd-dim]');
    for (var k = 0; k < dims.length; k++) {
      dims[k].disabled = unknown;
      if (unknown) clearFieldError(dims[k]);
    }
    var dimWrap = root.querySelector('[data-rsd-dims]');
    if (dimWrap) dimWrap.classList.toggle('is-disabled', unknown);
    var slatField = root.querySelector('[data-rsd-slat-field]');
    if (slatField) {
      slatField.hidden = ['200', '800', '800HP'].indexOf(series) !== -1;
      $('tech_slat').disabled = slatField.hidden;
    }
  }

  /* ---------- persistence (this tab only; no contact data is ever collected here) ---------- */
  function save() {
    try {
      var data = {};
      for (var i = 0; i < form.elements.length; i++) {
        var el = form.elements[i];
        if (!el.name || el.name === 'company_website') continue;
        if (el.type === 'radio') { if (el.checked) data[el.name] = el.value; }
        else if (el.type === 'checkbox') data[el.name] = el.checked;
        else data[el.name] = el.value;
      }
      sessionStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) { /* storage unavailable: nothing to do */ }
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      for (var i = 0; i < form.elements.length; i++) {
        var el = form.elements[i];
        if (!el.name || !(el.name in data)) continue;
        if (el.type === 'radio') el.checked = (data[el.name] === el.value);
        else if (el.type === 'checkbox') el.checked = !!data[el.name];
        else el.value = data[el.name];
      }
    } catch (e) { /* ignore corrupt or blocked storage */ }
  }

  /* ---------- series prefill: ?series=500 or any [data-rsd-series] link ---------- */
  function setSeries(code, announce) {
    var sel = $('series');
    if (!sel || !SERIES[code]) return false;
    sel.value = code;
    syncConditionals();
    save();
    if (announce && statusEl) statusEl.textContent = SERIES[code] + ' selected for your quote request.';
    return true;
  }
  function setSheetModel(code) {
    var sel = $('sheet_model');
    if (!sel || val('series') !== '200') return;
    var models = ['201', '201HD', '202', '202HD', '203', '203IM', '204', '204IM'];
    for (var i = 0; i < models.length; i++) {
      if (models[i].toLowerCase() === String(code || '').toLowerCase()) {
        sel.value = models[i];
        save();
        return;
      }
    }
  }
  function seriesFromUrl() {
    try {
      var m = /[?&]series=([^&#]+)/i.exec(window.location.search);
      if (!m) return;
      var want = decodeURIComponent(m[1]).toLowerCase();
      for (var code in SERIES) if (code.toLowerCase() === want) {
        setSeries(code, false);
        var model = /[?&]model=([^&#]+)/i.exec(window.location.search);
        if (model) setSheetModel(decodeURIComponent(model[1]));
        return;
      }
    } catch (e) { /* ignore malformed query */ }
  }
  function syncSeriesUrl() {
    try {
      var url = new URL(window.location.href);
      if (val('series')) url.searchParams.set('series', val('series'));
      else url.searchParams.delete('series');
      if (val('series') === '200' && val('sheet_model')) url.searchParams.set('model', val('sheet_model'));
      else url.searchParams.delete('model');
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {}
  }
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest ? ev.target.closest('[data-rsd-series]') : null;
    if (!link) return;
    var code = link.getAttribute('data-rsd-series');
    if (code === 'help') { var s = $('series'); if (s) { s.value = ''; syncConditionals(); save(); } }
    else {
      setSeries(code, true);
      if (link.hasAttribute('data-rsd-model')) setSheetModel(link.getAttribute('data-rsd-model'));
    }
    syncSeriesUrl();
    if (!step2.hidden) showStep(1);
  });

  /* ---------- validation ---------- */
  function fieldWrap(el) { return el.closest('.rsd-field') || el.closest('fieldset') || el.parentNode; }
  function clearFieldError(el) {
    var wrap = fieldWrap(el);
    if (!wrap) return;
    wrap.classList.remove('has-error');
    el.removeAttribute('aria-invalid');
    var described = (el.getAttribute('aria-describedby') || '').split(' ').filter(function (id) { return id && id !== (el.id || el.name) + '-error'; });
    if (described.length) el.setAttribute('aria-describedby', described.join(' '));
    else el.removeAttribute('aria-describedby');
    var msg = wrap.querySelector('.rsd-error');
    if (msg) msg.parentNode.removeChild(msg);
  }
  function setFieldError(el, text) {
    var wrap = fieldWrap(el);
    clearFieldError(el);
    wrap.classList.add('has-error');
    el.setAttribute('aria-invalid', 'true');
    var msg = document.createElement('p');
    msg.className = 'rsd-error';
    msg.id = (el.id || el.name) + '-error';
    msg.textContent = text;
    wrap.appendChild(msg);
    var described = (el.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x.indexOf('-error') === -1; });
    described.push(msg.id);
    el.setAttribute('aria-describedby', described.join(' '));
  }
  function intIn(name, min, max) {
    var raw = val(name);
    if (raw === '') return null;
    if (!/^\d+$/.test(raw)) return NaN;
    var n = parseInt(raw, 10);
    return (n < min || n > max) ? NaN : n;
  }

  function validate() {
    var errors = [];
    function fail(name, text) {
      var el = $(name);
      if (el && el.length && !el.tagName) el = el[0];
      if (el) setFieldError(el, text);
      errors.push({ el: el, text: text });
    }
    var all = form.querySelectorAll('[aria-invalid="true"]');
    for (var i = 0; i < all.length; i++) clearFieldError(all[i]);

    if (!val('application')) fail('application', 'Choose how the opening is used, or pick "Other".');

    var qty = intIn('quantity', 1, 999);
    if (qty === null || isNaN(qty)) fail('quantity', 'Enter a quantity from 1 to 999.');

    if (val('size_unknown') !== 'yes') {
      var wf = intIn('width_ft', 0, 100), wi = intIn('width_in', 0, 11);
      var hf = intIn('height_ft', 0, 100), hi = intIn('height_in', 0, 11);
      if (wf === null || isNaN(wf)) fail('width_ft', 'Enter the opening width in whole feet (0 to 100), or check "measurements not available yet".');
      else if (isNaN(wi)) fail('width_in', 'Width inches must be a whole number from 0 to 11.');
      else if (wf === 0 && !wi) fail('width_ft', 'Opening width must be greater than zero.');
      if (hf === null || isNaN(hf)) fail('height_ft', 'Enter the opening height in whole feet (0 to 100), or check "measurements not available yet".');
      else if (isNaN(hi)) fail('height_in', 'Height inches must be a whole number from 0 to 11.');
      else if (hf === 0 && !hi) fail('height_ft', 'Opening height must be greater than zero.');
    }

    if (!scrub(val('city'), 40)) fail('city', 'Enter the project city.');
    if (!scrub(val('state'), 30)) fail('state', 'Enter the project state or province.');
    if (val('ship_different') === 'yes') {
      if (!scrub(val('ship_city'), 40)) fail('ship_city', 'Enter the delivery city, or uncheck the different delivery location box.');
      if (!scrub(val('ship_state'), 30)) fail('ship_state', 'Enter the delivery state or province.');
    }
    return errors;
  }

  function showErrors(errors) {
    if (!errorBox) return;
    if (!errors.length) { errorBox.hidden = true; errorBox.innerHTML = ''; return; }
    var html = '<p><strong>Please fix ' + errors.length + (errors.length === 1 ? ' item' : ' items') + ' before continuing:</strong></p><ul>';
    for (var i = 0; i < errors.length; i++) {
      var id = errors[i].el ? (errors[i].el.id || '') : '';
      html += '<li>' + (id ? '<a href="#' + id + '">' : '') + errors[i].text.replace(/</g, '&lt;') + (id ? '</a>' : '') + '</li>';
    }
    errorBox.innerHTML = html + '</ul>';
    errorBox.hidden = false;
    errorBox.focus();
  }

  /* ---------- summary ---------- */
  function ft(nameFt, nameIn) { return (val(nameFt) || '0') + ' ft ' + (val(nameIn) || '0') + ' in'; }
  function label(name) {
    var el = $(name);
    if (!el) return '';
    if (el.tagName === 'SELECT') { var o = el.options[el.selectedIndex]; return o ? o.text.trim() : ''; }
    return val(name);
  }
  function yn(name, detailName, detailLabel, max) {
    var v = val(name);
    var out = v === 'yes' ? 'Yes' : v === 'no' ? 'No' : 'Not sure';
    if (v === 'yes' && detailName) {
      var d = $(detailName) && $(detailName).tagName === 'SELECT' ? label(detailName) : scrub(val(detailName), max);
      if (d) out += ' - ' + detailLabel + ': ' + d;
    }
    return out;
  }

  function buildSummary() {
    var lines = [];
    var series = val('series');
    lines.push('ROLLING STEEL DOOR QUOTE REQUEST (ASTA)');
    lines.push('Series: ' + (SERIES[series] || 'Help me choose'));
    if (series === '200') lines.push((root.getAttribute('data-model-summary-label') || '200 Series model') + ': ' + label('sheet_model'));
    lines.push('Application: ' + label('application'));
    lines.push('Project type: ' + (label('project_type') || 'Not sure'));
    lines.push('Quantity (identical doors): ' + val('quantity'));
    lines.push('Opening (W x H): ' + (val('size_unknown') === 'yes' ? 'Measurements not available yet' : ft('width_ft', 'width_in') + ' wide x ' + ft('height_ft', 'height_in') + ' high'));
    lines.push('Insulation needed: ' + yn('need_insulation'));
    lines.push('Fire rating required: ' + yn('need_fire', 'fire_rating', 'rating'));
    lines.push('Wind-load design required: ' + yn('need_wind', 'wind_detail', 'requirement', 60));
    lines.push('High-cycle / frequent use: ' + yn('need_cycle', 'cycle_detail', 'cycles per day', 30));

    var op = 'Operation: ' + (label('operation') || 'Help me choose');
    if (val('operation') === 'motor') {
      var bits = ['phase: ' + (label('motor_phase') || 'Not sure')];
      if (scrub(val('motor_voltage'), 20)) bits.push('voltage: ' + scrub(val('motor_voltage'), 20));
      if (scrub(val('motor_hp'), 20)) bits.push('HP: ' + scrub(val('motor_hp'), 20));
      op += ' (' + bits.join('; ') + ')';
    }
    lines.push(op);

    var tech = [];
    function add(lbl, v) { if (v && v !== 'Not sure') tech.push(lbl + ': ' + v); }
    add('Gauge / material', scrub(val('tech_gauge'), 50));
    add('Color / finish', scrub(val('tech_color'), 50));
    add('Jamb / wall', label('tech_jamb'));
    add('Mounting', label('tech_mount'));
    if (!$('tech_slat').disabled) add('Slat profile', label('tech_slat'));
    add('Handing', label('tech_hand'));
    add('Headroom / sideroom', scrub(val('tech_clearance'), 80));
    if (tech.length) lines.push('Technical details (customer preference, to be confirmed): ' + tech.join('; '));

    var loc = scrub(val('city'), 40) + ', ' + scrub(val('state'), 30) + (scrub(val('zip'), 12) ? ' ' + scrub(val('zip'), 12) : '');
    lines.push('Project location: ' + loc);
    if (val('ship_different') === 'yes') {
      lines.push('Deliver to: ' + scrub(val('ship_city'), 40) + ', ' + scrub(val('ship_state'), 30) + (scrub(val('ship_zip'), 12) ? ' ' + scrub(val('ship_zip'), 12) : '') + ' (full delivery address to be confirmed with quote)');
    } else {
      lines.push('Deliver to: same area as project');
    }
    lines.push('Timing: ' + (label('timing') || 'Not sure'));
    lines.push('Quote request only - not an order or approval.');
    lines.push('Source: americandoorsupply.com' + window.location.pathname);
    lines.push('');
    lines.push('Notes (finishes, vision panels, seals, locks, existing door, anything else):');
    lines.push('');
    return lines.join('\n');
  }

  /* ---------- step 2: native HighLevel form ---------- */
  function clearEmbed() {
    if (slowTimer) { window.clearTimeout(slowTimer); slowTimer = null; }
    var slowNote = root.querySelector('[data-rsd-slow]');
    if (slowNote) slowNote.hidden = true;
    embedEl.innerHTML = '';
    embedEl.classList.remove('is-loaded');
    loadedSummary = null;
  }

  function buildEmbed(summary) {
    clearEmbed();
    if (!FORM_ID) return false;
    var src = FORM_HOST + encodeURIComponent(FORM_ID) +
      '?website_inquiry_type=' + encodeURIComponent('Quote request') +
      '&howcanwehelp=' + encodeURIComponent(summary);
    var truncatedNote = root.querySelector('[data-rsd-truncated]');
    var tooLong = src.length > MAX_URL;
    if (tooLong) {
      // Field limits keep the summary far below this, but never transfer a partial
      // summary silently: prefill a paste marker and tell the visitor to paste.
      src = FORM_HOST + encodeURIComponent(FORM_ID) + '?website_inquiry_type=' + encodeURIComponent('Quote request') +
        '&howcanwehelp=' + encodeURIComponent('ROLLING STEEL DOOR QUOTE REQUEST (ASTA)\n[Paste your copied door details here]\n');
    }
    if (truncatedNote) truncatedNote.hidden = !tooLong;
    var transferNote = root.querySelector('[data-rsd-transfer-note]');
    if (transferNote) transferNote.textContent = tooLong ? 'Copy your door details above and paste them into the message box below.' : 'Check that your door details appear in the message box below. If they are missing, use Copy door details above and paste them before sending.';
    var frame = document.createElement('iframe');
    frame.src = src;
    frame.id = 'inline-' + FORM_ID;
    frame.title = 'Contact details for your rolling steel door quote request (' + FORM_NAME + ')';
    frame.setAttribute('referrerpolicy', 'no-referrer');
    frame.setAttribute('data-layout', "{'id':'INLINE'}");
    frame.setAttribute('data-trigger-type', 'alwaysShow');
    frame.setAttribute('data-trigger-value', '');
    frame.setAttribute('data-activation-type', 'alwaysActivated');
    frame.setAttribute('data-activation-value', '');
    frame.setAttribute('data-deactivation-type', 'neverDeactivate');
    frame.setAttribute('data-deactivation-value', '');
    frame.setAttribute('data-form-name', FORM_NAME);
    frame.setAttribute('data-layout-iframe-id', 'inline-' + FORM_ID);
    frame.setAttribute('data-form-id', FORM_ID);
    frame.className = 'rsd-embed__frame';
    var slow = root.querySelector('[data-rsd-slow]');
    slowTimer = window.setTimeout(function () { slowTimer = null; if (slow && frame.parentNode === embedEl && !embedEl.classList.contains('is-loaded')) slow.hidden = false; }, 12000);
    frame.addEventListener('load', function () {
      if (frame.parentNode !== embedEl) return;
      if (slowTimer) { window.clearTimeout(slowTimer); slowTimer = null; }
      if (slow) slow.hidden = true;
      embedEl.classList.add('is-loaded');
    });
    embedEl.appendChild(frame);
    loadedSummary = summary;
    return true;
  }

  function showStep(n) {
    step1.hidden = n !== 1;
    step2.hidden = n !== 2;
    for (var i = 0; i < stepItems.length; i++) {
      var on = String(n) === stepItems[i].getAttribute('data-rsd-stepitem');
      stepItems[i].classList.toggle('is-current', on);
      if (on) stepItems[i].setAttribute('aria-current', 'step'); else stepItems[i].removeAttribute('aria-current');
    }
    if (n === 1) {
      // The loaded native form is kept (hidden) so nothing typed in it is lost.
      // It is rebuilt on Continue only if the door details actually changed.
      var first = root.querySelector('[data-rsd-step1-title]');
      if (first) first.focus();
    } else {
      var head = root.querySelector('[data-rsd-step2-title]');
      if (head) head.focus();
    }
    root.scrollIntoView({ block: 'start' });
  }

  var busy = false;
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (busy) return;
    var trap = $('company_website');
    if (trap && trap.value) return;                       // honeypot: silently ignore bots
    var errors = validate();
    showErrors(errors);
    if (errors.length) return;
    save();
    var summary = buildSummary();
    var ok = true;
    var hasLoadedForm = loadedSummary !== null && embedEl.querySelector('iframe');
    if (hasLoadedForm && loadedSummary !== summary) {
      var reload = window.confirm('Your door details changed, so the contact form needs to reload with the new details. Anything already typed in the contact form (contact details or notes) will be cleared.\n\nReload the contact form now?');
      if (!reload) { if (statusEl) statusEl.textContent = 'Door details not applied. The contact form still shows your earlier details.'; return; }
    }
    busy = true;
    summaryEl.textContent = summary.replace(/\n\nNotes \([\s\S]*$/, '').trim();
    if (!hasLoadedForm || loadedSummary !== summary) ok = buildEmbed(summary);
    var missing = root.querySelector('[data-rsd-noform]');
    if (missing) missing.hidden = ok;
    showStep(2);
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'agds_rolling_quote_continue', rsd_series: val('series') || 'help' }); } catch (e) { /* analytics optional */ }
    window.setTimeout(function () { busy = false; }, 800);
  });

  form.addEventListener('change', function () { syncConditionals(); save(); syncSeriesUrl(); });
  form.addEventListener('input', function (ev) {
    save();
    if (ev.target && ev.target.getAttribute && ev.target.getAttribute('aria-invalid') === 'true') clearFieldError(ev.target);
  });

  var editBtn = root.querySelector('[data-rsd-edit]');
  if (editBtn) editBtn.addEventListener('click', function () { showStep(1); });

  var copyBtn = root.querySelector('[data-rsd-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var text = summaryEl.textContent;
    function done(ok) { if (statusEl) statusEl.textContent = ok ? 'Door details copied.' : 'Copy failed. Select the text and copy it manually.'; copyBtn.textContent = ok ? 'Copied' : 'Copy door details'; window.setTimeout(function () { copyBtn.textContent = 'Copy door details'; }, 2500); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(false); });
    else {
      var r = document.createRange(); r.selectNodeContents(summaryEl);
      var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      var ok = false; try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      done(ok);
    }
  });

  restore();
  seriesFromUrl();
  syncConditionals();
  root.classList.add('is-ready');
})();
